import * as React from 'react';
import { Cell, Grid } from 'styled-css-grid';
import { Typography } from '../../../../DesignSystemV2/Typography';

export const ReviewItem = (props) => {
  const { title, description, content } = props;
  return (
    <Grid columns="1fr max-content">
      <Cell middle>
        <Typography.Text variant="medium/16">{title}</Typography.Text>
      </Cell>
      <Cell middle>
        <Typography.Text variant="bold/16" color="green100">
          {content}
        </Typography.Text>
      </Cell>
      <Cell middle width={2}>
        <Typography.Text variant="regular/14" color="black80">
          {description}
        </Typography.Text>
      </Cell>
    </Grid>
  );
};
